import MapLocationDefinition from "../model/MapLocationDefinition";

export default class MapLocationAvailabilityEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {MapLocationDefinition} mapLocation 
     */
    constructor(type, mapLocation) {
        this.type = type;
        this.mapLocation = mapLocation;
    }
}

MapLocationAvailabilityEvent.LOCATION_AVAILABLE = "MapLocationAvailabilityEvent.LOCATION_AVAILABLE";
MapLocationAvailabilityEvent.LOCATION_UNAVAILABLE = "MapLocationAvailabilityEvent.LOCATION_UNAVAILABLE";